import axios from 'axios';

// API base URL - fallback to production URL if env var is not set
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api/attendance-system-way0.onrender.com';

export const attendanceService = {
  // Record or update attendance
  recordAttendance: async (attendanceData) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/api/attendance`, attendanceData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get attendance records with filters
  getAttendance: async (params = {}) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/attendance`, { 
      params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get attendance statistics
  getAttendanceStats: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/attendance/stats`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get attendance records for specific date
  getAttendanceByDate: async (date) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/attendance/date/${date}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Delete attendance record
  deleteAttendance: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_BASE_URL}/api/attendance/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  }
};
